<template>
  <ion-toast
    :color="props.color"
    :is-open="isOpen"
    :icon="props.icon ? props.icon : null"
    :duration="props.duration"
    @didDismiss="isOpen = false"
    :message="props.message"
    position="bottom"
    :swipe-gesture="props.swipeToClose ? 'vertical' : null"
  >
  </ion-toast>
</template>
<script setup>
import { IonToast } from "@ionic/vue";
import { ref, watch } from "vue";
const props = defineProps({
  isToastOpen: {
    type: Boolean,
    required: true,
  },
  duration: {
    type: Number,
    default: 3000,
  },
  message: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
  },
  color: {
    type: String,
    default: "primary",
  },
  swipeToClose: {
    type: Boolean,
    default: true,
  },
});
const isOpen = ref(props.isToastOpen);
watch(
  () => props.isToastOpen,
  (newVal) => {
    isOpen.value = newVal;
  }
);
</script>
